import React, { useEffect, useRef, useState } from 'react';
import { Outlet, Link } from "react-router-dom";
import './SkillPathGroupComponent.scss';
import { ISkillGroup } from '../model/SkillGroup.model';
import { ISkill } from '../model/Skill.model';
import { useForm } from 'react-hook-form';

const SkillPathSkillCheckboxComponent: React.FC<{
  skill: ISkill;
  index: number;
  allSelected: boolean | null;
  isMobileClient: boolean;
  stateUpdated(event: { skill: ISkill, checked: boolean }): void;
}> = (props: {
  skill: ISkill, index: number, allSelected: boolean | null, isMobileClient: boolean,
  stateUpdated(event: { skill: ISkill, checked: boolean }): void;
}) => {
    const { register, handleSubmit, reset } = useForm();
    const [checked, setChecked] = useState(props.allSelected);
    const HandleSkillCheckboxUpdate = (event: any, skillId: string) => {
      let checked = event.target.checked;
      props.stateUpdated({ skill: props.skill, checked: checked })
    };
    if (props.allSelected !== null && props.allSelected !== checked) {
      var rs = {};
      setChecked(props.allSelected);
      (rs as any)[props.skill.SkillId] = (props.allSelected) ? "checked" : null;
      reset(rs)
    }
    if (props.isMobileClient) {
      return (
        <div className='skillpath-group-mobile-checkbox-label-container' key={props.skill.SkillId}>
          <label htmlFor={props.skill.SkillId} className='dis-flex-grow-1 clr-black fnt-wght-500 cursor-pointer'>{props.skill.skillName}</label>
          <input id={props.skill.SkillId} {...register(props.skill.SkillId)} type='checkbox' className='mobile' defaultValue={(checked !== null) ? "checked" : ""} onChange={(e) => HandleSkillCheckboxUpdate(e, props.skill.SkillId)} />
        </div>
      );
    } else {
      return (
        <>
          <input id={props.skill.SkillId} {...register(props.skill.SkillId)} type='checkbox' className='on-dark m-r--75' onChange={(e) => HandleSkillCheckboxUpdate(e, props.skill.SkillId)} />
          <label htmlFor={props.skill.SkillId} key={props.skill.SkillId}>{props.skill.skillName}</label>
        </>
      );
    }
  }

export interface SkillPathGroupComponentState {
  skillPathGroup: any;
  isMobileClient: boolean,
  resetCheckboxes: boolean,
  skillFilterUpdate(group: ISkillGroup, ids: string[]): void,
  checkAll: boolean
}

const SkillPathGroupComponent: React.FC<SkillPathGroupComponentState> = (props: {
  skillPathGroup: any, isMobileClient: boolean, resetCheckboxes: boolean,
  skillFilterUpdate(group: ISkillGroup, ids: string[]): void,
  checkAll: boolean
}) => {
  const [selectedFilteredSkillIds, setSelectedFilteredSkillIds] = useState<string[]>([]);
  const [allSelected, setAllSelected] = useState<boolean>(false);
  const [autoCheckAll, setAutoCheckAll] = useState<boolean>(false);
  const HandleAllClick = (event: any) => {
    var checked = event.target.checked;
    if (checked) {
      var ids: string[] = [];
      var skills = (props.skillPathGroup as ISkillGroup).skills;
      skills?.forEach(sk => ids.push(sk.SkillId));
      setSelectedFilteredSkillIds(ids);
      props.skillFilterUpdate(props.skillPathGroup, ids);
    } else {
      setSelectedFilteredSkillIds([]);
      props.skillFilterUpdate(props.skillPathGroup, []);

    }
    setAllSelected(checked);
  }

  if (props.resetCheckboxes && selectedFilteredSkillIds.length > 1) {
    HandleAllClick({ target: { checked: false } });
  }

  
  useEffect(() => {
    if (!allSelected && props.checkAll) {
      setAutoCheckAll(props.checkAll);
      HandleAllClick({ target: { checked: true } });
    }
  }, [autoCheckAll]);
  


  const HandleSkillCheckBoxUpdated = (event: { skill: ISkill, checked: boolean }) => {
    if (event.checked) {
      selectedFilteredSkillIds.push(event.skill.SkillId);
    } else {
      selectedFilteredSkillIds.splice(selectedFilteredSkillIds.indexOf(event.skill.SkillId), 1);
    }
    console.log('filter checkbox: ', event.checked, event.skill.SkillId, selectedFilteredSkillIds);
    props.skillFilterUpdate(props.skillPathGroup, selectedFilteredSkillIds);
  }
  if (props.isMobileClient) {
    return (
      <>

        <h2 className='clr-black fnt-wght-700 m-l-1-5 m-r-1-5 m-t-2'>{props.skillPathGroup.skillGroupName}</h2>
        <ul className='reset'>
          <li className="skillpath-group-mobile-filter-skills-li">
            <div className='skillpath-group-mobile-checkbox-label-container'>
              <label htmlFor={"all" + props.skillPathGroup.indexNumber} className='dis-flex-grow-1 clr-black fnt-wght-500 cursor-pointer'>All</label>
              <input defaultChecked={props.checkAll} id={"all" + props.skillPathGroup.indexNumber} type="checkbox"  onChange={e => HandleAllClick(e)} className='mobile' />
            </div>
            
          </li>
          {
            props.skillPathGroup.skills && props.skillPathGroup.skills.length > 0 &&
            props.skillPathGroup.skills.map((item: ISkill, index: number) => (
              <li className={index === props.skillPathGroup.skills.length - 1 ? 'skillpath-group-mobile-filter-skills-li last' : 'skillpath-group-mobile-filter-skills-li'} key={item.skillGroupId + index}>
                <SkillPathSkillCheckboxComponent skill={item} index={index} allSelected={allSelected} isMobileClient={props.isMobileClient} stateUpdated={HandleSkillCheckBoxUpdated} />
              </li>
            ))
          }
        </ul>
      </>
    );

  } else {
    return (
      <>
        <h3 className='fnt-wght-600 m-b--75 h4-size'>{props.skillPathGroup.skillGroupName}</h3>
        <ul className='reset'>
          <li className='skillpath-group-desktop-filter-skills-li'>
            <label className='cursor-pointer'>
              <input type="checkbox" id="all" className='on-dark m-r--75' defaultChecked={props.checkAll} onChange={e => HandleAllClick(e)} />
              All
            </label>
          </li>
          {
            props.skillPathGroup.skills && props.skillPathGroup.skills.length > 0 &&
            props.skillPathGroup.skills.map((item: any, index: number) => (
              <li className='skillpath-group-desktop-filter-skills-li' key={item.skillGroupId + index}>
                <SkillPathSkillCheckboxComponent skill={item} index={index} allSelected={allSelected} isMobileClient={props.isMobileClient} stateUpdated={HandleSkillCheckBoxUpdated} />
              </li>
            ))
          }
        </ul>
      </>
    );
  }
}
export default SkillPathGroupComponent;

